/** Imports */
import {z} from 'zod';
import {zMongoObjectId} from '@/types/utils';
import {createSelectSchema} from 'drizzle-zod';
import {index, integer, jsonb, pgTable, text, timestamp, uniqueIndex, varchar} from 'drizzle-orm/pg-core';


/** Drizzle schemas */
export const dGroups = pgTable('groups', {
    id: integer('id')
        .primaryKey()
        .generatedAlwaysAsIdentity(),
    legacyMongoId: varchar('legacy_mongo_id', {length: 24})
        .notNull(),
    organizationMongoId: varchar('organization_mongo_id', {length: 24})
        .notNull(),
    name: text('name')
        .notNull(),
    note: text('note')
        .notNull()
        .default(''),
    pageMongoIds: jsonb('page_mongo_ids')
        .$type<Array<string>>()
        .notNull()
        .default([]),
    createdAt: timestamp('created_at', {mode: 'date'})
        .notNull()
        .defaultNow(),
    updatedAt: timestamp('updated_at', {mode: 'date'})
        .notNull()
        .defaultNow()
        .$onUpdate(() => new Date()),
}, (table) => [
    uniqueIndex('groups_legacy_mongo_id_uidx')
        .on(table.legacyMongoId)
        .concurrently(),
    index('groups_organization_mongo_id_idx')
        .on(table.organizationMongoId)
        .concurrently(),
]);


/** Zod schemas */
export const zGroup = createSelectSchema(dGroups, {
    legacyMongoId: zMongoObjectId,
    organizationMongoId: zMongoObjectId,
    pageMongoIds: z.array(zMongoObjectId).default(() => []),
});


/** Types */
export type Group = z.infer<typeof zGroup>;
